import React from "react"; 
import Route1 from "./routes";

function App() {
  return (
    <Route1/>
  );
}

export default App;
